// Others
import axiosClient from './axiosClient';
import { IGlobal } from '~/utils/interface/global';
import { urlApiGlobal } from '~/utils/constants/apis';
import { IQueryParamBase } from '~/utils/interface/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';

const globalApi = {
  getListGlobal: (params: IQueryParamBase) => {
    const url = urlApiGlobal.getListGlobal;
    return axiosClient.get<IBaseResponse<IListDataResponse<IGlobal[]>>>(url, { params });
  },
};

export default globalApi;
